import { render, staticRenderFns } from "./page-choose-selected.vue?vue&type=template&id=3d5edda9&"
import script from "./page-choose-selected.vue?vue&type=script&lang=js&"
export * from "./page-choose-selected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports